// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__fPdBC","active":"Pagination_active__UvdUP","inactive":"Pagination_inactive___V2md"};